import React from 'react';

import { createRoot, Root } from 'react-dom/client';

import { GroupHeader, GroupHeaders } from './components/group-headers/group-headers';

const headerRoots = new WeakMap<Element, Root>();

export const renderHeaderComponent = (
	timelineHeaders: GroupHeader[],
	timelineContainerRef: React.RefObject<HTMLDivElement>
): void => {
	let container = timelineContainerRef.current?.querySelector('.gantt-headers-container');

	if (!container) {
		container = document.createElement('div');
		container.className = 'gantt-headers-container';
		timelineContainerRef.current?.querySelector('.vis-timeline')?.appendChild(container);
	}

	let root = headerRoots.get(container);
	if (!root) {
		root = createRoot(container);
		headerRoots.set(container, root);
	}

	root.render(<GroupHeaders headers={timelineHeaders} timelineContainer={timelineContainerRef.current} />);
};
